import { render } from "./page9.vue?vue&type=template&id=031906f5&scoped=true"
import script from "./page9.vue?vue&type=script&lang=js"
export * from "./page9.vue?vue&type=script&lang=js"

import "./page9.vue?vue&type=style&index=0&id=031906f5&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031906f5"]])

export default __exports__